// ─── Appointment Form Models ───────────────────────────────────────────────────────

export interface AppointmentOnlineData {
  appointment_first_name: string;
  appointment_last_name: string;
  company_id: number;
  location_id: number;
  appointment_phone: string;
  appointment_email: string;
  appointment_dob: string;
  appointment_health_card: string;
  terms: boolean;
  website: string; // Honeypot field for anti-spam
}

// ─── Error Map ────────────────────────────────────────────────────────────────

export type AppointmentFormErrors = Partial<Record<keyof AppointmentOnlineData, boolean>>;

// ─── Initial State ────────────────────────────────────────────────────────────

export const INITIAL_APPOINTMENT: AppointmentOnlineData = {
  appointment_first_name: '',
  appointment_last_name: '',
  company_id: 0,
  location_id: 0,
  appointment_phone: '',
  appointment_email: '',
  appointment_dob: '',
  appointment_health_card: '',
  terms: false,
  website: ''
};


// ─── Helpers ──────────────────────────────────────────────────────────────────

export const toggleArrayItem = (arr: string[], item: string): string[] =>
  arr.includes(item) ? arr.filter(i => i !== item) : [...arr, item];

// ─── Validation ───────────────────────────────────────────────────────────────

export const validateForm = (form: AppointmentOnlineData): [AppointmentFormErrors] => {
  const errors: AppointmentFormErrors = {};
  
  if (!form.appointment_first_name.trim()) errors.appointment_first_name = true;
  //if (!form.appointment_last_name.trim()) errors.appointment_last_name = true;
  if (!form.appointment_phone.trim()) errors.appointment_phone = true;
  //if (!form.appointment_dob) errors.appointment_dob = true;
  if (!form.terms) errors.terms = true;

  return [errors];
};